import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["drawer", "overlay", "content"];
  static values = { url: String, loaded: Boolean };

  connect() {
    this.loadedValue = false;
  }

  async open(event) {
    if (event) event.preventDefault();

    if (!this.loadedValue && this.hasUrlValue) {
      await this.loadContent();
    }

    this.drawerTarget.classList.remove("translate-x-full");
    this.overlayTarget.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");
  }

  close(event) {
    if (event) event.preventDefault();
    this.drawerTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close(event);
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close(event);
    }
  }

  async loadContent() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      if (response.ok) {
        const html = await response.text();
        this.contentTarget.innerHTML = html;
        this.loadedValue = true;
      }
    } catch (error) {
      this.contentTarget.innerHTML =
        '<p class="text-gray-500 text-sm p-4">Failed to load changelog.</p>';
    }
  }
}
